import { Navigate } from "react-router-dom"
import { isUserLoggedIn } from "./libs/utils"
import { STORAGE } from "./libs/storage"

/**
 * Route-level access guard (matches the sidebar's feature-based gating).
 * - Not logged in        -> redirect to /login
 * - Missing required feature -> redirect to /overview (dashboard)
 *
 * `feature` should be the same code the sidebar uses (e.g. "CANCELLED_RIDES",
 * "TRANSACTIONS"), which comes from the user's features list. This closes the
 * hole where a logged-in user could type a URL and open a page they have no
 * menu/permission for.
 */
const RouteGuard = ({ feature, userTypes, children }) => {
  if (!isUserLoggedIn()) {
    return <Navigate to="/login" replace />
  }
  if (feature) {
    const accessList = STORAGE.getAccessList()
    if (!accessList.includes(feature)) {
      return <Navigate to="/overview" replace />
    }
  }
  if (userTypes && userTypes.length) {
    const user = STORAGE.getUserDetails()
    if (!userTypes.includes(user?.user_type)) {
      return <Navigate to="/overview" replace />
    }
  }
  return children
}

export default RouteGuard
